// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"0b5b0fe3","128":"e2ecbe73","278":"e9f375da","640":"7dc88fac","856":"4a22ab22","873":"af064553","949":"58237067"}[chunkId] + ".chunk.js";
};